<div class="p-0">
    <div class="row carousel-wrapper">
        <ngx-slick-carousel class="carousel"
                            #slickModal="slick-carousel"
                            [config]="slideConfig">

            <div ngxSlickItem *ngFor="let item of dataSourceCategory.data" class="slide">
                <div class="partner-item mx-2 mt-2 p-0">
                    <a class="box" (click)="onClickCategory(item.gnCategoryID)" href="javascript:void(0);">
                        <img [src]="apiURL + item.photoPath" alt="image">
                    </a>
                    <h6 class="mt-3 custom-title">
                        <ng-template *ngIf="SelectedLanguage == 'ar'; then other_ItemAr; else other_ItemEn"></ng-template>
                        <ng-template #other_ItemAr>{{ item.nameAr }}</ng-template>
                        <ng-template #other_ItemEn>{{ item.name }}</ng-template>
                    </h6>
                </div>
            </div>

        </ngx-slick-carousel>
    </div>
</div>

